module.exports = __webpack_public_path__ + "images/avatars/female/9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/9.png
// module id = w2og
// module chunks = 118